<template>
    <div>
        <page-title>插件订单</page-title>
        <page-body>
            <list-header>
                <div flex="dir:left box:last cross:center" style="height: 40px;">
                    <div>
                        <router-link to="/dashboard/plugin-order/edit"><el-button type="primary" size="small" round>购买插件</el-button></router-link>
                    </div>
                    <div>
                        <el-input v-model="keyword"
                                  @keyup.enter.native="search()"
                                  size="mini"
                                  placeholder="插件/站点/域名/单号"
                                  suffix-icon="el-icon-search"/>
                    </div>
                </div>
            </list-header>
            <el-table v-loading="loading" :data="list" style="width: 100%">
                <el-table-column prop="plugin.display_name" label="插件"></el-table-column>
                <el-table-column prop="host" label="站点">
                    <template slot-scope="scope">
                        <div>名称: {{scope.row.host.name}}</div>
                        <div>域名: {{scope.row.host.domain}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="order_no" label="订单">
                    <template slot-scope="scope">
                        <div>订单号: {{scope.row.order_no}}</div>
                        <div>下单时间: {{scope.row.add_time}}</div>
                        <div>金额: <span style="text-decoration: line-through">{{scope.row.price}}</span></div>
                        <div>实际支付: <span>{{scope.row.pay_price}}</span></div>
                    </template>
                </el-table-column>
                <el-table-column prop="is_pay" label="状态">
                    <template slot-scope="scope">
                        <span style="color: #909399" v-if="scope.row.is_pay === 0">未支付</span>
                        <span style="color: #67C23A" v-else-if="scope.row.is_pay === 1">已授权</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <template v-if="scope.row.status===1">
                            <router-link :to="'/dashboard/host/edit?id=' + scope.row.id">编辑</router-link>
                        </template>
                        <template v-else>-</template>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    style="margin: 20px -5px;padding: 0"
                    background
                    layout="prev, pager, next"
                    :page-size="parseInt(pagination && pagination.pageSize ? pagination.pageSize : 10)"
                    @current-change="pageChange"
                    :total="parseInt(pagination && pagination.totalCount ? pagination.totalCount : 0)">
            </el-pagination>
        </page-body>
    </div>
</template>

<script>
import axios from '@/axios'

export default {
    data() {
        return {
            loading: true,
            list: null,
            pagination: null,
            keyword: ''
        }
    },
    created() {
        this.loadData(0)
    },
    methods: {
        loadData(page) {
            this.getList(page).then(e => {
                this.list = e.list
                this.pagination = e.pagination
            })
        },
        getList(page) {
            return new Promise(resolve => {
                this.loading = true
                axios({
                    url: 'user/plugin-order/index',
                    params: {
                        page: page,
                        keyword: this.keyword
                    }
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        resolve(e.data.data)
                    }
                })
            })
        },
        search() {
            this.loadData(0)
        },
        pageChange(page) {
            this.loadData(page - 1)
        }
    }
}
</script>

<style scoped>

</style>
